import useSources from "~/ui-rtk/hooks/sources"
import useDepVar from "~/ui-rtk/hooks/dep-var"
import useBaselineRevenueMetric from "~/ui-rtk/hooks/baseline-revenue-metric"

const content = {
  id: "clsaphypc000608jy5jef5svc",
  slug: "/brand-value/overview",
  icon: null,
  title: "Overview",
  parent: {
    slug: "/brand-value",
    title: "Brand Value",
  },
  metadata: {
    visibleToRoles: ["SUPER_ADMIN"],
  },
  order: 20.1,
}

export default function useConnect() {
  const { isLoading: isSourcesDataLoading } = useSources()
  const { depVar, depVarScaler, toggleAmazon, amazonEnabled } = useDepVar()
  const baselineMetric = useBaselineRevenueMetric()

  return {
    content,
    toggleAmazon,
    amazonEnabled,
    cubeQueryParams: {
      depVar,
      depVarScaler,
      baselineMetric,
    } as Record<string, string | string[]>,
    isLoading: isSourcesDataLoading,
  }
}
